module.exports = __webpack_public_path__ + "media/images/svg/trends-a2a24bb98c4f33b70a74474ce740c307.svg";